//==========import components===============
import SubPagesLayout from 'layouts/SubPagesLayout';
import AboutEvent from 'components/common/AboutEvent';
import JoinEventOrganizer from 'components/common/JoinEventOrganizer';
import { ourTeamObj } from 'helpers/commonHelper';
import OurTeamListing from 'components/about-us/our-team/OurTeamListing';

const OurTeamPage = () => {
  return (
    <div className='ourTeamPage DBlock relative'>
      <AboutEvent data={ourTeamObj} />
      <OurTeamListing />
      <JoinEventOrganizer bgColor='white' />
    </div>
  );
};

export default SubPagesLayout({ route: 'about us/our team' })(OurTeamPage);
